import React, { Component } from 'react'
/**
 * Renderiza somente o calendário.
 * */ 
export default class CalendarCustom extends Component {
  constructor(props) {
    super(props)
    this.state = {
      days: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
      months: [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
      ],
      weekDays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      lastMonth: 11,
      month: 0,
      nextMonth: 1,
      year: 0,
      currentMonth: 0,
      currentYear: 0,
      calendar: [
        { id: 'week-1', data: [0, 0, 0, 0, 0, 0, 0] },
        { id: 'week-2', data: [0, 0, 0, 0, 0, 0, 0] },
        { id: 'week-3', data: [0, 0, 0, 0, 0, 0, 0] },
        { id: 'week-4', data: [0, 0, 0, 0, 0, 0, 0] },
        { id: 'week-5', data: [0, 0, 0, 0, 0, 0, 0] },
        { id: 'week-6', data: [0, 0, 0, 0, 0, 0, 0] },
      ],
      holidays: [],
      holiday: '',
      indexOf: -1
    }

    this.previousCalendar = this.previousCalendar.bind(this)
    this.nextCalendar = this.nextCalendar.bind(this)
  }

  componentWillMount () {
    const now = new Date()
    const currentMonth = now.getMonth()
    const currentYear = now.getFullYear()

    this.setState({
      currentMonth,
      currentYear,
      month: currentMonth,
      year: currentYear
    })

    this.setCalendar(new Date(currentYear, currentMonth, 1))
  }

  setMonth(date) {
    const month = date.getMonth()
    const lastMonth = month === 0 ? 11 : month - 1
    const nextMonth = month === 11 ? 0 : month + 1

    this.setState({
      lastMonth,
      month,
      nextMonth,
    })

    return { lastMonth, month, nextMonth }
  }

  arrayDaysList (day, month, year) {
    const schedule = this.props.schedule;

    let date = []
    for ( let i in schedule) {
      for (let selectDay of schedule[i]) {
        const splited = selectDay.split('/')
        const sYear = Number(splited[2])
        const sMonth = Number(splited[1])
        const sDay = Number(splited[0])

        if (sYear === year && sMonth === month && sDay === day) {
          date.push({day, i})
        }
      }
    }

    return date
  }

  setCalendar(date) {
    const { lastMonth, month, nextMonth } = this.setMonth(date)
    const year = date.getFullYear()
    const weekday = date.getDay()
    const days = this.checkLeapYear(year)
    const schedule = this.props.schedule
    let nextMonthDay = 0

    const firstWeek = this.state.calendar[0].data.map((day, index) => {
      if (index < weekday) {
        const value = (days[lastMonth] - (weekday - index)) + 1
        return {
          value,
          class: 'day--soft',
          month: lastMonth,
        }
      }
      const value = (index - weekday) + 1
      const arrayDays = this.arrayDaysList(value, (month + 1), year) || []
      const dayClass = arrayDays.length
      const indexDays = arrayDays.length ? Number(arrayDays[0].i) : null
      return {
        value: value,
        class: dayClass ? 'hasClass pointer' : '',
        onClick:dayClass,
        year,
        month,
        index: indexDays,
        schedule: schedule
      }
    })
    const secondWeek = this.state.calendar[0].data.map((day, index) => {
      const value = firstWeek[6].value + index + 1
      const arrayDays = this.arrayDaysList(value, (month + 1), year) || []
      const dayClass = arrayDays.length
      const indexDays = arrayDays.length ? Number(arrayDays[0].i) : null
      return {
        value,
        class: dayClass ? 'hasClass pointer' : '',
        onClick:dayClass,
        year,
        month,
        index: indexDays,
        schedule: schedule
      }
    })
    const thirdWeek = this.state.calendar[0].data.map((day, index) => {
      const value = secondWeek[6].value + index + 1
      const arrayDays = this.arrayDaysList(value, (month + 1), year) || []
      const dayClass = arrayDays.length
      const indexDays = arrayDays.length ? Number(arrayDays[0].i) : null
      return {
        value,
        class: dayClass ? 'hasClass pointer' : '',
        onClick:dayClass,
        year,
        month,
        index: indexDays,
        schedule: schedule
      }
    })
    const forthWeek = this.state.calendar[0].data.map((day, index) => {
      const value = thirdWeek[6].value + index + 1
      const arrayDays = this.arrayDaysList(value, (month + 1), year) || []
      const dayClass = arrayDays.length
      const indexDays = arrayDays.length ? Number(arrayDays[0].i) : null
      return {
        value,
        class: dayClass ? 'hasClass pointer' : '',
        onClick:dayClass,
        year,
        month,
        index: indexDays,
        schedule: schedule
      }
    })
    const fifthWeek = this.state.calendar[0].data.map((day, index) => {
      if (forthWeek[6].value + index + 1 > days[month]) {
        nextMonthDay += 1
        return {
          value: nextMonthDay,
          class: 'day--soft',
          month: nextMonth,
        }
      }
      const value = forthWeek[6].value + index + 1
      const arrayDays = this.arrayDaysList(value, (month + 1), year) || []
      const dayClass = arrayDays.length
      const indexDays = arrayDays.length ? Number(arrayDays[0].i) : null
      return {
        value,
        class: dayClass ? 'hasClass pointer' : '',
        onClick:dayClass,
        year,
        month,
        index: indexDays,
        schedule: schedule
      }
    })
    const sixthWeek = this.state.calendar[0].data.map((day, index) => {
      if (fifthWeek[6].value + index + 1 > days[month] || fifthWeek[6].value < 10) {
        nextMonthDay += 1
        return {
          value: nextMonthDay,
          class: 'day--soft',
          month: nextMonth,
        }
      }

      const value = fifthWeek[6].value + index + 1
      const arrayDays = this.arrayDaysList(value, (month + 1), year) || []
      const dayClass = arrayDays.length
      const indexDays = arrayDays.length ? Number(arrayDays[0].i) : null
      return {
        value,
        class: dayClass ? 'hasClass pointer' : '',
        onClick:dayClass,
        year,
        month,
        index: indexDays,
        schedule: schedule
      }
    })

    this.setState({
      month,
      year,
      calendar: [
        { id: 'week-1', data: firstWeek },
        { id: 'week-2', data: secondWeek },
        { id: 'week-3', data: thirdWeek },
        { id: 'week-4', data: forthWeek },
        { id: 'week-5', data: fifthWeek },
        { id: 'week-6', data: sixthWeek },
      ],
    })
  }

  checkLeapYear(year) {
    let days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
    // if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
    //   days = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
    // }
    this.setState({
      days,
    })
    return days
  }

  previousCalendar() {
    const month = this.state.month !== 0 ? this.state.month - 1 : 11
    const year = this.state.month !== 0 ? this.state.year : this.state.year - 1
    this.setCalendar(new Date(year, month, 1))
    this.props.onChangeMonth(month)
  }

  nextCalendar() {
    const month = this.state.month !== 11 ? this.state.month + 1 : 0
    const year = this.state.month !== 11 ? this.state.year : this.state.year + 1
    this.setCalendar(new Date(year, month, 1))
    this.props.onChangeMonth(month)
  }

  onClickDate (day, dataDays) {
    const index = day.schedule[day.index]

    this.props.onClickDate(index[0], day.value)
  }

  setIndexSelected (index) {
    if (this.state.indexOf !== index && index !== null) {
      this.setState({
        indexOf: index
      })
    }
  }

  renderDays (data) {
    const selected = this.props.selectedDay
    const dataDays = data

    return (
      data.map((day) => {
        if (day.onClick) {
          const indexOf = day.value === selected ? day.index : null
          this.setIndexSelected(indexOf)
          return (
            <div
              key={`${day.month}${day.value}`}
              className={`day ${day.class} ${this.state.indexOf === day.index ? 'selected' : ''}`}
              onClick={() => this.onClickDate(day, dataDays)}
            >
              {day.value < 10 && day.value !== ' ' ? `0${day.value}` : day.value}
            </div>
          )
        }
        return (
          <div
            key={`${day.month}${day.value}`}
            className={`day ${day.class}`}
          >
            {day.value < 10 && day.value !== ' ' ? `0${day.value}` : day.value}
          </div>
        )
      })
    )
  }

  render() {
    return (
      <div className="calendar">
        <div className="calendar-header">
          <span className="button-container button-container--left">
            <button onClick={this.previousCalendar} className="button-content button-content--left" />
          </span>
          <span className="calendar-header-date">{`${this.state.months[this.state.month]} ${this.state.year}`}</span>
          <span className="button-container button-container--right">
            <button onClick={this.nextCalendar} className="button-content button-content--right" />
          </span>
        </div>
        <div className="week">
          {this.state.weekDays.map(weekDay => <div key={weekDay} className="weekday">{weekDay}</div>)}
        </div>
        {this.state.calendar.map(week =>
          <div key={week.id} className="week">
            {this.renderDays(week.data)}
          </div>,
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/workshop/customCalendar.js